var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hasConfig("optionItems")
    ? _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.defaultValue") } },
        [
          _c("el-input", {
            attrs: { type: "text" },
            on: { change: _vm.emitDefaultValueChange },
            model: {
              value: _vm.optionModel.defaultValue,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "defaultValue", $$v)
              },
              expression: "optionModel.defaultValue",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }